import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
export function TeamPage() {
  usePageSEO({
    title: 'Team | Design Flow Digitals',
    description: 'Meet the team behind Design Flow Digitals. Shopify developers, designers, and strategists dedicated to building premium ecommerce experiences.'
  });
  return <div className="pt-32 pb-20" data-id="element-885">
      <section className="px-6 md:px-12 max-w-5xl mx-auto text-center mb-24" data-id="element-886">
        <h1 className="text-5xl md:text-7xl font-bold mb-8" data-id="element-887">Meet the Team</h1>
        <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-888">
          Design Flow Digitals is powered by a team of designers, developers,
          and ecommerce specialists.
        </p>
      </section>

      <section className="section-padding bg-black border-y border-white/5" data-id="element-889">
        <div className="max-w-4xl mx-auto text-center" data-id="element-890">
          <h2 className="text-3xl font-bold mb-12" data-id="element-891">Our Collective Expertise</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-892">
            {['Shopify Development', 'UX/UI Design', 'Ecommerce Growth', 'Performance Engineering'].map((skill, i) => <div key={i} className="glass-card p-6 border-white/10" data-id="element-893">
                <p className="font-medium text-white" data-id="element-894">{skill}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="section-padding" data-id="element-895">
        <div className="max-w-4xl mx-auto" data-id="element-896">
          <h2 className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-12 text-center" data-id="element-897">
            The People Behind the Work
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-898">
            {/* Pankaj Maurya */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-899">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-900">
                <img src="https://cdn.magicpatterns.com/uploads/mGfabHy4m1VsnCVj3nADJ1/Pankaj_Template_Profile_(1).png" alt="Pankaj Maurya" className="w-full h-full object-cover object-top" data-id="element-901" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-902">
                Pankaj Maurya
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-903">Founder</p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-904">
                Founder of Design Flow Digitals. Full-stack developer with a
                Master's in Commerce, bringing deep ecommerce expertise and
                technical skill to every project. Over 1,000 Shopify stores
                delivered for global brands and entrepreneurs.
              </p>
            </div>

            {/* Saloni Gupta */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-905">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-906">
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-907" />
                <span className="text-3xl font-bold text-white/20" data-id="element-908">SG</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-909">
                Saloni Gupta
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-910">
                Performance Engineer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-911">
                Combines performance engineering with UX/UI design expertise to
                craft fast, beautiful ecommerce experiences that convert
                visitors into customers.
              </p>
            </div>

            {/* Samuel Masih */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-912">
              <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#D4AF37]/30 overflow-hidden mb-5" data-id="element-913">
                <img src="https://cdn.magicpatterns.com/uploads/9gTnZstt2EDzKocCdbCK3V/1718263422794.jpg" alt="Samuel Masih" className="w-full h-full object-cover object-top" data-id="element-914" />
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-915">
                Samuel Masih
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-916">
                Lead Developer
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-917">
                Full-stack Software Engineer specializing in the MERN stack,
                React, Next.js, and scalable web applications. Driven by
                curiosity and a deep analytical mindset, Samuel delivers
                end-to-end solutions from clean UI design to robust backend
                systems.
              </p>
            </div>

            {/* Join Us */}
            <div className="glass-card p-6 border-white/10 text-center hover:border-[#D4AF37]/30 transition-colors duration-300 flex flex-col items-center justify-center" data-id="element-918">
              <div className="w-28 h-28 mx-auto rounded-full bg-gradient-to-br from-gray-800 to-black border-2 border-dashed border-[#D4AF37]/30 flex items-center justify-center overflow-hidden relative mb-5" data-id="element-919">
                <span className="text-3xl text-[#D4AF37]/40" data-id="element-920">+</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-921">
                Join Our Team
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-4" data-id="element-922">
                We're Hiring
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-923">
                We're always looking for talented developers and designers
                passionate about ecommerce.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}